import { Box, IconButton, Link, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react';
import Button from '../../../components/Button';
import CreateIcon from '@mui/icons-material/Create';
import { ManageAssessment } from '../../course/lessonPlan/assessments/ManageV2';
import { useParams } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useCourse } from '../../course/hooks';
import DeleteIcon from '@mui/icons-material/Delete';


const Assessment = () => {
    const { courseId } = useParams();
    const [chapterId, setChapterId] = useState();
    const { loadLessonPlan, lessonPlan, deleteAssessment, updateAssessments } = useCourse();
    const [sectionId, setSectionId] = useState();
    const [assessments, setAssessments] = useState();
    const [edit, setEdit] = useState(false);

    const removeAssessment = (assessmentId) => {
        if (!confirm('Are you sure to delete this assessment?')) { return; }
        deleteAssessment({ id: assessmentId })
        updateAssessments({ sectionId, chapterId, assessmentId });
    }

    useEffect(() => {
        loadLessonPlan({ id: courseId })
    }, [])

    useEffect(() => {
        if (courseId && lessonPlan && lessonPlan?.sections) {
            const section = lessonPlan?.sections?.[0];
            setSectionId(section?.sectionId)
            if (section) {
                const chapter = section?.chapters[0];
                setChapterId(chapter?.chapterId)
                setAssessments(chapter?.assessments)
            }
        }
    }, [lessonPlan, courseId])

    const handleEdit = () => {
        setEdit(!edit)
    }

    return (
        <Box >
            <Typography
                align="left"
                variant="h1"
                color="primary.blue"
                sx={{
                    margin: '0',
                    fontWeight: '700',
                    lineHeight: '1.5',
                    fontSize: '2rem',
                }}> Assessments
            </Typography>
            {assessments?.length > 0 &&
                <Box>
                    {assessments?.map((assessment, index) => {
                        return (
                            <Box key={assessment?.id}>
                                {!edit && <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    background: '#B2B0FF',
                                    alignItems: 'center',
                                    p: 1,
                                    mt: 2,
                                    borderRadius: '5px',
                                }}>
                                    {assessment?.name}
                                    <div style={styles.actionBtn} >
                                        <IconButton>
                                            <Tooltip title="Edit Assessment">
                                                <CreateIcon onClick={handleEdit} sx={{ color: '#000', cursor: 'pointer', fontSize: '1.2rem' }} />
                                            </Tooltip>
                                        </IconButton>
                                        <IconButton>
                                            <Tooltip title="Delete Assessment">
                                                <DeleteIcon onClick={() => removeAssessment(assessment?.id)} sx={{ color: '#000', cursor: 'pointer', fontSize: '1.2rem' }} />
                                            </Tooltip>
                                        </IconButton>
                                    </div>
                                </Box>}
                                {edit &&
                                    <ManageAssessment
                                        assessmentId={assessment?.id}
                                        chapterId={chapterId}
                                        sectionId={sectionId}
                                        edit={edit}
                                        setEdit={setEdit}
                                    />
                                }
                            </Box>
                        )
                    }
                    )}
                </Box>
            }
            {!assessments?.length > 0 && <Box sx={{ mt: 2 }}>
                {!edit &&
                    <Link style={styles.assessmentsLink} onClick={handleEdit}>Create Assessment <ArrowForwardIcon sx={{ ml: 1 }} /></Link>
                }
                {edit &&
                    <ManageAssessment
                        chapterId={chapterId}
                        sectionId={sectionId}
                        edit={edit}
                        setEdit={setEdit}
                    />
                }
            </Box>
            }
            {
                <Box sx={{ m: 1, textAlign: 'center' }}>
                    <Typography sx={{ color: 'grey', fontSize: '0.8em' }}>
                        (Make sure to click "<span style={{ color: '#000', fontWeight: '600' }}>Save Changes</span>" Before & After Creating, Editing or deleting the assessment )
                    </Typography>
                </Box>
            }
        </Box>
    )
}

const styles = {
    actionBtn: {
        display: 'flex',
        alignItems: 'center'
    },
    assessmentsLink: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '5px',
        textAlign: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
    },
}
export default Assessment